export default function getRowStyle(index: number, length: number) {
  return index === length ? { borderBottom: '1px solid #999' } : {};
}
